import { useEffect, useState } from 'react';

import { TIMING } from '../utilities/WordpressConstants';

export const useTimers = () => {
  const [stickyVRM, setStickyVRM] = useState(false);

  useEffect(() => {
    const stickyTimer = setTimeout(() => setStickyVRM(true), TIMING.STICKY_VRM_DELAY);

    return () => {
      clearTimeout(stickyTimer);
    };
  }, []);

  return { stickyVRM };
};
